import { PlessViewUtilsSub } from './../../kymw00/pless-view-utils-sub.service';
import { KYMW0800Component } from './kymw0800.component';

/**
 * 実績履歴画面の値を管理するクラス
 *
 * @export KYMW0800Model
 * @class KYMW0800Model
 */
export class KYMW0800Model {

  kymw0800Component: KYMW0800Component;
  // Ｐコード
  public pCode: string;
  // Ｐコードリスト
  public pCodeList: Array<any> = null;
  // 商品名
  public guideGoodsName: string;
  // 規格名
  public guideStandardName: string;
  // 総件数
  public totalNum: number;
  // 開始件数
  public startDispNum: number;
  // 終了件数
  public endDispNum: number;

  prevPageDisabled: boolean = true;
  nextPageDisabled: boolean = true;

  // 「実績履歴一覧」情報のリスト
  public resultList: Array<any> = new Array<any>();

  // バインド用変数
  public resultDetail: boolean = <boolean>false;

  /**
   * サーバから取得したデータで実績履歴一覧を更新する(表示)
   *
   * @param serverData
   */
  public updateResultList(serverData: any): void {
    // サーバ取得情報をManageへ設定
    // 実績履歴一覧

    if (serverData.TotalNum === '0' || (PlessViewUtilsSub.isEmpty(this.pCode))) {											// 総件数がゼロ、またはＰコード未指定の場合

      this.resultList = new Array<any>();
      this.kymw0800Component.updateOutputBtnEnableMode(false);
      this.kymw0800Component.updateMakedWKTFlag(false);
      this.kymw0800Component.updateMakedTotalCnt(0);
      this.kymw0800Component.updateSessionId(serverData.SessionId);
      return;
    } else {
      this.resultList = serverData.PublishResultData;
      this.kymw0800Component.updateOutputBtnEnableMode(true);
      this.kymw0800Component.updateMakedWKTFlag(true);
      this.kymw0800Component.updateMakedTotalCnt(Number(serverData.TotalNum));
      this.kymw0800Component.updateSessionId(serverData.SessionId);
    }

    // 総件数
    this.totalNum = serverData.TotalNum;
    // 開始件数
    this.startDispNum = serverData.StartDispNum;
    // 終了件数
    this.endDispNum = serverData.EndDispNum;

    this.kymw0800Component.cmb_PCodeList.nativeElement.focus();

  }

  /**
   * コンテキストメニュー
   * 「計画数自動セット」、「別商品の計画数自動セット」
   * コールバックメソッド
   *
   * @param serverData
   */
  public setRegistPlanNum(serverData: any): void {
    // 呼び出し元へ情報を返却
    this.kymw0800Component.setOutputInfo();
  }
}
